module.exports = __webpack_public_path__ + "static/media/eden.50947b38.jpg";